export default "__VITE_ASSET__vULCfaka__"